import { render, staticRenderFns } from "./RealtimeData.vue?vue&type=template&id=dfe912f6&scoped=true&"
import script from "./RealtimeData.vue?vue&type=script&lang=js&"
export * from "./RealtimeData.vue?vue&type=script&lang=js&"
import style0 from "./RealtimeData.vue?vue&type=style&index=0&id=dfe912f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe912f6",
  null
  
)

export default component.exports